import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { EnvConfigBrand } from '@core/config-models';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgClass } from '@angular/common';
import {
  CrntIconButton,
  CrntVisuallyHidden,
  CrntIcon,
  CrntButton,
} from '@essent/current-web-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TranslatePipe } from '@ngx-translate/core';
import { ScIconPipe } from '@core/jss-utils';

import { CollapseDirection } from './collapse-direction.model';
import { CollapseDirectionPipe } from './collapse-direction.pipe';

@Component({
  selector: 'wl-off-canvas',
  templateUrl: './off-canvas.component.html',
  styleUrls: [
    './off-canvas.component.ed.scss',
    './off-canvas.component.essent.scss',
  ],
  standalone: true,
  imports: [
    CSCaptureDirective,
    FaIconComponent,
    NgClass,
    CrntIconButton,
    AutomationIdDirective,
    CrntVisuallyHidden,
    CrntIcon,
    CrntButton,
    TranslatePipe,
    ScIconPipe,
    CollapseDirectionPipe,
  ],
})
export class OffCanvasComponent {
  private openValue = false;

  @Output()
  public openChange = new EventEmitter<boolean>();

  @Output()
  public back = new EventEmitter<void>();

  get open() {
    return this.openValue;
  }

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() set open(isOpen: boolean) {
    this.openValue = isOpen;
    this.openChange.emit(isOpen);
  }

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() backgroundColor?: 'white' | 'light';

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public direction!: CollapseDirection;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public icon!: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public openButtonTitle?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public title?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public showToggleIcon?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public showTitleCollapsed?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public showBackButton?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public brand?: EnvConfigBrand = 'essent';

  public toggleOffCanvas() {
    this.open = !this.open;
  }

  public get hasIconOnlyButtons() {
    return this.brand === 'ed';
  }
}
